import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ShipmentDashboardOverview } from './shipment-dashboard.model';

@Injectable({ providedIn: 'root' })
export class ShipmentDashboardService {
  private readonly apiUrl = `${environment.restApiUrl}shipments/dashboard`;

  constructor(private http: HttpClient) {}

  getOverview(params: HttpParams): Observable<ShipmentDashboardOverview> {
    return this.http.get<ShipmentDashboardOverview>(`${this.apiUrl}/overview`, { params });
  }
}
